const footerNav = [
  {
    title: "栏目导航",
    links: [
      { href: "#live", label: "现场直击" },
      { href: "#hot", label: "今日热榜" },
      { href: "#columns", label: "主题分类" },
      { href: "#digest", label: "热点速报" },
    ],
  },
  {
    title: "内容专题",
    links: [
      { href: "#columns", label: "明星八卦" },
      { href: "#columns", label: "社会百态" },
      { href: "#columns", label: "科技风向" },
      { href: "#columns", label: "影视娱乐" },
    ],
  },
  {
    title: "关于与帮助",
    links: [
      { href: "#about", label: "关于我们" },
      { href: "#faq", label: "常见问题" },
      { href: "#subscribe", label: "订阅速报" },
      { href: "#top", label: "返回顶部" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5" aria-label="17吃瓜首页">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-400 text-foreground-950">
                <i className="ri-water-flash-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="leading-none">
                <span className="font-heading block text-xl font-bold text-background-50">17吃瓜</span>
                <span className="mt-1 block text-[10px] text-background-200/80">围观不迷路，速看不慌张</span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-200/80">
              面向全网用户的热点资讯与现场直击平台，聚合当下最值得围观的事件，倡导理性吃瓜、实时围观，让每一次关注都有价值。
            </p>
            <div className="mt-6 flex items-center gap-2">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-line", "ri-douban-line", "ri-rss-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#top"
                    aria-label="社区入口"
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-accent-400 hover:text-foreground-950"
                  >
                    <i className={`${icon} text-base`} aria-hidden="true"></i>
                  </a>
                )
              )}
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-6">
            {footerNav.map((group) => (
              <nav key={group.title} aria-label={group.title}>
                <h4 className="mb-4 text-sm font-semibold text-background-50">{group.title}</h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-background-200/80 transition-colors hover:text-accent-300"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-background-50/15 pt-6">
          <p className="text-xs text-background-200/70">
            © {new Date().getFullYear()} 17吃瓜 热点资讯门户 · 理性围观，从每一个真实瞬间开始
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-200/70">
            <a href="#faq" className="transition-colors hover:text-accent-300">内容原则</a>
            <a href="#about" className="transition-colors hover:text-accent-300">关于我们</a>
            <a href="#subscribe" className="transition-colors hover:text-accent-300">商务合作</a>
          </div>
        </div>
      </div>
    </footer>
  );
}